<template>
    <div class="box">
        <!--<div class="top">-->
        <!--<img src="@/assets/back.png" alt="" @click="back">-->
        <!--返回-->
        <!--</div>-->
        <h3 class="title">{{details.memberName}}</h3>
        <div class="details" v-html="details.menberDetailInfo">{{details.menberDetailInfo==null?'':details.menberDetailInfo}}</div>
        <!-- <img src="/static/img/fenxiang.png" class="fenxiang" @click="tofenxiang" v-show="isshowfenxiang"> -->
    </div>
</template>

<script>
    import { Toast } from 'vant';
    export default {
        name: "teamMemberDetail",
        data () {
            return {
                id:'',
                details:{},
                isshowfenxiang:true,
            }
        },
        created () {
            this.id = this.$route.query.TMid
        },
        mounted () {
            this.getDetails()
            var userAgent = navigator.userAgent;
            if (userAgent.indexOf("android") > -1) {
                this.isshowfenxiang=true
            } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
                this.isshowfenxiang=true
            } else {
                this.isshowfenxiang=false
            }
        },
        methods:{
            back () {
                history.go(-1)
            },
            getDetails () {
                this.$axios.post('api/teamMembers/findTeamMembersById',{memberId:this.id}).then(res => {
                    // console.log('3333',res.data.data)
                    this.details = res.data.data.data;
                })
            },
            tofenxiang(){
                try {
                    let newsurl='https://chglobal.1atoshi.top/#/teamMemberDetail?TMid=' + this.id
                    let _this=this
                    var userAgent = navigator.userAgent;
                    if (userAgent.indexOf("android") > -1) {
                        window.Android.shareNewsFromWebsite(_this.details.memberName,newsurl,_this.details.readMemberImgMobile);
                    } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
                        let datas=JSON.stringify({fxtitle:_this.details.memberName,fxurl:newsurl,fxcoverimg:_this.details.readMemberImgMobile})
                        window.webkit.messageHandlers.shareNewsToiPhone.postMessage(datas);
                    }
                } catch (error) {
                    Toast("此应用暂不支持分享");
                }
                
            }
        }
    }
</script>

<style scoped>
    .top{
        line-height: 1.3rem;
        height:1.3rem;
        background:#fff;
        color:#666666;
        font-size:.3rem;
        border-bottom:.12rem solid #F5F5F5;
    }
    .top img{
        margin-left:.3rem;
        vertical-align: middle;
        width:.3rem;
        height:.31rem;
    }
    .title{
        padding:.3rem 0.3rem 0rem;
        text-align: center;
        border-bottom:1px solid #000000;
    }
    .details{
        padding:.2rem .3rem 0;
    }
    .fenxiang{
        width:0.7rem;
        height:0.7rem;
        position: fixed;
        bottom:1.1rem;
        right:0.3rem;
        z-index: 1000;
    }
</style>

<style>
    .details p img{
        width:6.9rem !important;
        height:auto !important;
        margin:.1rem auto;
        /* margin-left: -0.57rem; */
    }
    .details p{
        width:6.9rem !important;
        margin:0 auto;
        /* text-indent: 2em; */
    }
    .details a{
        color:#3f9ce8;
        text-decoration:underline;
        display: inline-block;
        width:6.9rem;
        word-wrap:break-word;
    }
</style>



// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/teamMemberDetail.vue